<template>
  <aha-section>
    <template #header>
      <h5>{{ $i18nPresenter.t('Current Plan') }}</h5>
    </template>
    <template #body>
      <table class="table-plan">
        <colgroup>
          <col class="w-1/2 md:w-1/3">
          <col class="w-1/2 md:w-2/3">
        </colgroup>
        <tbody class="w-full">
          <tr v-if="!data.subscription">
            <td colspan="2" class="py-2 italic">
              {{ $i18nPresenter.t(`You can upgrade to a Monthly or Yearly plan to use AhaSlides for more than one event (and save on cost!)`) }}
            </td>
          </tr>
          <tr>
            <td class="table-plan-property">
              <i class="mr-1 fas fa-cart-arrow-down fa-fw" />
              {{ $i18nPresenter.t('Your plan:') }}
            </td>
            <td
              class="py-2 font-bold table-plan-value"
              :class="getPlanColor(plan)"
            >
              {{ plan.name }}
            </td>
          </tr>
          <tr>
            <td class="table-plan-property">
              <i class="mr-1 fas fa-user fa-fw" />
              {{ $i18nPresenter.t('Owner:') }}
            </td>
            <td class="py-2 table-plan-value">
              {{ currentUser.email }}
            </td>
          </tr>
          <tr>
            <td class="table-plan-property">
              <i class="mr-1 fas fa-users fa-fw" />
              {{ $i18nPresenter.t('Participant limit:') }}
            </td>
            <td class="py-2 table-plan-value plan-limit">
              {{ plan.limit | formatNumber }}
            </td>
          </tr>
          <tr>
            <td class="align-top table-plan-property">
              <i class="mr-1 far fa-calendar-alt fa-fw" />
              {{ $i18nPresenter.t('Event date:') }}
            </td>
            <td class="py-2 table-plan-value">
              <span v-if="data.oneTime.timeEnd">
                {{ data.oneTime.startTime | dateTimeStamp }}
              </span>
              <div v-if="!data.oneTime.timeEnd">
                <p>
                  {{ $i18nPresenter.t('Not started yet') }}
                </p>
                <p
                  class="mt-1 text-xs"
                >
                  {{ $i18nPresenter.t(`Your event day will start when you have more than 7 participants joining your presentation simultaneously and last for 24 hours`) }}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td class="table-plan-property">
              <i class="mr-1 far fa-calendar-check fa-fw" />
              {{ $i18nPresenter.t('End date:') }}
            </td>
            <td class="py-2 table-plan-value">
              <span v-if="data.oneTime.timeEnd">
                {{ data.oneTime.timeEnd | dateTimeStamp }}
              </span>
              <div v-if="!data.oneTime.timeEnd">
                {{ $i18nPresenter.t('24 hours since your event starts') }}
              </div>
            </td>
          </tr>

          <tr>
            <td class="table-plan-property">
              <i class="mr-1 fas fa-money-check-alt fa-fw" />
              {{ $i18nPresenter.t('One-time cost:') }}
            </td>
            <td class="table-plan-value">
              {{ plan.price }} USD
            </td>
          </tr>
          <tr v-if="data.oneTime.coupon">
            <td class="align-top table-plan-property">
              <i class="mr-1 fas fa-gift fa-fw" />
              {{ $i18nPresenter.t('Discount applied:') }}
            </td>
            <td class="table-plan-value">
              <div>
                <span
                  :class="{'sub-has-coupon line-through pr-1': data.oneTime.coupon}"
                >{{ plan.price }} USD</span>
                <span class="font-bold">{{ data.oneTime.amount }} USD</span>
              </div>
              <div
                class="text-xs label-coupon text-base-80"
              >
                {{ $i18nPresenter.t('Promo code:') }}
                {{ data.oneTime.coupon.id }} - {{ data.oneTime.coupon.name }}
              </div>
              <div class="text-xs label-coupon text-base-80">
                {{ $i18nPresenter.t('Duration:') }} {{ data.oneTime.coupon.duration }}
                <span
                  v-if="data.oneTime.coupon.duration == 'repeating'"
                >({{ data.oneTime.coupon.duration_in_months }} {{ $i18nPresenter.t('months') }})</span>
              </div>
            </td>
          </tr>

          <tr>
            <td class="table-plan-property">
              <aha-icon name="coin" class="-mt-0.5 -ml-0.5" />
              {{ $i18nPresenter.t('Credit balance:') }}
            </td>
            <td
              class="py-2 table-plan-value"
            >
              <span v-if="currentUser.balance">
                {{ (0 - parseFloat(currentUser.balance)) | currencyFormat(getCurrency) }} {{ getCurrency }}
              </span>
              <span v-else>{{ 0 | currencyFormat(getCurrency) }} {{ getCurrency }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </template>
  </aha-section>
</template>
<script  >
import { mapState } from 'vuex'

export default {
  name: 'OneTimePlanSection',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState({
      plan: (state) => state.plan,
      currentUser: (state) => state.currentUser,
    }),
    getCurrency() {
      if (this.currentUser.currency === 'eur') return 'EUR'
      return 'USD'
    },
  },

  methods: {

    getPlanColor(subscription) {
      this.$emit('getPlanColor', subscription)
    },
  },
}
</script>
